/**
 * Referral update type markers stored in description text.
 * Format: ###Adjuster Update### at the start of the message.
 */
/** Known update types — order is stable for future pickers. */
export const REFERRAL_UPDATE_TYPES = [
    { id: 'adjuster', label: 'Adjuster Update', shortLabel: 'Adjuster', cssClass: 'adjuster' },
    { id: 'admin', label: 'Admin Update', shortLabel: 'Admin', cssClass: 'admin' },
    { id: 'provider', label: 'Provider Update', shortLabel: 'Provider', cssClass: 'provider' },
    { id: 'manager', label: 'Manager Update', shortLabel: 'Manager', cssClass: 'manager' },
    { id: 'inspire', label: 'Inspire Update', shortLabel: 'Inspire', cssClass: 'inspire' },
    { id: 'system', label: 'System Update', shortLabel: 'System', cssClass: 'system' },
];
const MARKER_RE = /^###\s*([^#]+?)\s*###\s*(?:\r?\n)*/;
const byLabel = new Map(REFERRAL_UPDATE_TYPES.map((type) => [type.label.trim().toLowerCase(), type]));
export function referralUpdateMarker(type) {
    return `###${type.label}###`;
}
export function getReferralUpdateType(id) {
    const found = REFERRAL_UPDATE_TYPES.find((type) => type.id === id);
    if (!found) {
        throw new Error(`Unknown referral update type: ${id}`);
    }
    return found;
}
export function prependReferralUpdateType(description, typeId = 'adjuster') {
    const body = description.trim();
    const type = getReferralUpdateType(typeId);
    return `${referralUpdateMarker(type)}\n\n${body}`;
}
/** Strip a leading ###Type### marker and resolve the update type when known. */
export function parseReferralUpdateDescription(description) {
    const raw = description ?? '';
    const match = raw.match(MARKER_RE);
    if (!match) {
        return { type: null, body: raw.trim() || '' };
    }
    const label = match[1].trim();
    const type = byLabel.get(label.toLowerCase()) ?? null;
    const body = raw.slice(match[0].length).trim();
    return { type, body };
}
